import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { Menu, X } from "lucide-react";
import { API_URL, Button, BarreNavigation } from "./Dashboard";

const SI = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) navigate("/");
    else setUser(storedUser);

    fetchTickets();
  }, [navigate]);

  const fetchTickets = () => {
    fetch(`${API_URL}/obtenirTickets.php`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setTickets(data);
        else setTickets([]);
      })
      .catch(err => {
        console.error(err);
        setTickets([]);
      });
  };

  if (!user) return null;

  const peutSupprimerTicket = (ticket) => {
    return ["Responsable SI", "Chargé SI", "Chargée SI"].includes(user.poste) || user.identifiant === ticket.auteur;
  };

  const seDeconnecter = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  const ajouterTicket = () => {
    if (!titre.trim() || !description.trim()) return;
    fetch(`${API_URL}/ajouterTicket.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        titre,
        description,
        auteur: user.identifiant
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setTitre("");
          setDescription("");
          fetchTickets();
        } else alert(data.error || "Erreur lors de l'ajout");
      })
      .catch(console.error);
  };

  const supprimerTicket = (id) => {
    if (!peutSupprimerTicket) return;
    fetch(`${API_URL}/supprimerTicket.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) fetchTickets();
        else alert(data.error || "Erreur lors de la suppression");
      })
      .catch(console.error);
  };

  return (
    <div className="flex min-h-screen bg-gray-50 relative overflow-x-hidden">
        
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <div className={`
        fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-md transform transition-transform duration-300 ease-in-out
        lg:relative lg:translate-x-0
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
         <BarreNavigation 
            user={user} 
            deconnexion={seDeconnecter} 
            onNavigate={() => setIsMobileMenuOpen(false)}
         />
         <button 
            onClick={() => setIsMobileMenuOpen(false)}
            className="absolute top-4 right-4 lg:hidden text-gray-500"
        >
            <X size={24} />
        </button>
      </div>

      <main className="flex-1 p-4 lg:p-8 w-full">
        <header className="flex items-center justify-between mb-6 gap-4">
          <div className="flex items-center gap-3">
             {/* Bouton burger */}
             <button 
                className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                onClick={() => setIsMobileMenuOpen(true)}
            >
                <Menu size={24} />
            </button>
            {/* Taille de police réduite sur mobile pour éviter que le titre prenne trop de place */}
            <h1 className="text-xl md:text-2xl font-bold text-gris-sombre">Déposer un ticket à la SI</h1>
          </div>
          
          {/* Bouton déconnexion responsive */}
          <Button variant="outline" onClick={seDeconnecter} title="Se déconnecter">
            <span className="hidden sm:inline">Se déconnecter</span>
            <LucideIcons.LogOut size={16} className="sm:hidden" />
          </Button>
        </header>

        {/* Formulaire d’ajout */}
        <form className="bg-white p-4 rounded-xl shadow mb-6" onSubmit={(e) => { e.preventDefault(); ajouterTicket(); }}>
          <input type="text" value={titre} onChange={(e) => setTitre(e.target.value)} placeholder="Titre du ticket"
            className="w-full border rounded-lg px-3 py-2 mb-3" required
          />
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Décris ton problème ou ta demande"
            className="w-full border rounded-lg px-3 py-2 mb-3" rows="3" required
          />
          {/* Le bouton prend toute la largeur sur mobile pour faciliter le clic */}
          <Button type="submit" className="w-full sm:w-auto">Envoyer</Button>
        </form>

        {/* Liste des tickets */}
        <ul className="space-y-3">
          {tickets.map((t) => (
            <li key={t.id} className="bg-white p-4 rounded-xl shadow flex flex-col gap-2">
              <h2 className="font-semibold text-lg break-words">{t.titre}</h2>
              <p className="text-gray-700 whitespace-pre-wrap break-words">{t.description}</p>
              
              <div className="flex justify-between items-end mt-2">
                <p className="text-sm text-gray-500">Publié par {t.prenom} {t.nom}</p>
                
                {peutSupprimerTicket(t) && (
                    <button
                    onClick={() => supprimerTicket(t.id)}
                    className="p-2 rounded-full bg-red-600 hover:bg-red-700 text-white flex items-center justify-center transition-colors"
                    title="Supprimer le ticket"
                    >
                    <LucideIcons.Trash2 size={16} />
                    </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default SI;